import { CustomerForecast } from '@/coreInfrastructureModule/axios/generated/customerForecastManage';
import { ICustomerForecast } from '@/coreDomainsModule/entities/businessForCustomerForecast';

/**
 * APIからのresponseに含まれる客先内示をUI用に変換する
 */
export class CustomerForecastAdapter {
  /**
   * APIからのresponseに含まれる客先内示をUI用に変換する
   * @param response - APIレスポンス
   */
  public static adapt = (response: CustomerForecast): ICustomerForecast => {
    return {
      customerForecastResponsibleUserIdHistory: response.customerForecastResponsibleUserIdHistory,
      createdSupplierForecast: response.createdSupplierForecast,
      receivedYear: response.customerForecastReceivedYear,
      receivedMonth: response.customerForecastReceivedMonth,
      targetYear: response.customerForecastTargetYear,
      targetMonth: response.customerForecastTargetMonth,
      amount: response.customerForecastAmount,
      updateAt: response.updateAt,
    };
  };
}
